(function () {
    const versions = {
        // Do not set `node` — js-md5 (used by @react-pdf/renderer) treats
        // process.versions.node as Node.js and requires Buffer at import time.
        v8: '0.0.0',
        uv: '0.0.0',
        zlib: '0.0.0',
        ares: '0.0.0',
        modules: '0',
        nghttp2: '0.0.0',
        napi: '0',
        openssl: '0.0.0',
    };

    if (typeof globalThis !== 'undefined') {
        // Only set process if it doesn't exist, preserve existing properties
        if (!globalThis.process) {
            (globalThis as any).process = { env: {}, versions };
        } else {
            // Only set versions if it doesn't exist
            if (!globalThis.process.versions) {
                (globalThis as any).process.versions = versions;
            }
            // Ensure env exists
            if (!globalThis.process.env) {
                (globalThis as any).process.env = {};
            }
        }
        // core-js internal shared store key - only if it doesn't exist
        if (!(globalThis as any)['__core-js_shared__']) {
            (globalThis as any)['__core-js_shared__'] = {};
        }
        // Strip stale Node masquerade from prior polyfills / cached deps.
        if ((globalThis as any).process?.versions?.node) {
            delete (globalThis as any).process.versions.node;
        }
        // Ant Design v5 getRootPrefixCls polyfill - provides default implementation
        // This will be overridden by ConfigProvider when it initializes
        if (typeof (globalThis as any).getRootPrefixCls !== 'function') {
            (globalThis as any).getRootPrefixCls = function (suffixCls?: string, customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return suffixCls ? `ant-${suffixCls}` : 'ant';
            };
        }
        // Ant Design v5 getIconPrefixCls polyfill - provides default implementation
        // This will be overridden by ConfigProvider when it initializes
        if (typeof (globalThis as any).getIconPrefixCls !== 'function') {
            (globalThis as any).getIconPrefixCls = function (customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return 'anticon';
            };
        }
        // Ant Design v5 getTheme polyfill - provides default implementation
        // This will be overridden by ConfigProvider when it initializes
        if (typeof (globalThis as any).getTheme !== 'function') {
            (globalThis as any).getTheme = function (): undefined {
                return undefined;
            };
        }
        // Ant Design v5 getPrefixCls polyfill - CRITICAL for component rendering
        // This is the main prefix class function used by all Ant Design components
        if (typeof (globalThis as any).getPrefixCls !== 'function') {
            (globalThis as any).getPrefixCls = function (suffixCls?: string, customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return suffixCls ? `ant-${suffixCls}` : 'ant';
            };
        }
    }
    if (typeof window !== 'undefined' && window !== globalThis) {
        // Only set process on window if it doesn't exist
        if (!window.process) {
            (window as any).process = { env: {}, versions };
        } else {
            if (!window.process.versions) {
                (window as any).process.versions = versions;
            }
            if (!window.process.env) {
                (window as any).process.env = {};
            }
        }
        if ((window as any).process?.versions?.node) {
            delete (window as any).process.versions.node;
        }
        // Also set getRootPrefixCls on window for compatibility
        if (typeof (window as any).getRootPrefixCls !== 'function') {
            (window as any).getRootPrefixCls = function (suffixCls?: string, customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return suffixCls ? `ant-${suffixCls}` : 'ant';
            };
        }
        // Also set getIconPrefixCls on window for compatibility
        if (typeof (window as any).getIconPrefixCls !== 'function') {
            (window as any).getIconPrefixCls = function (customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return 'anticon';
            };
        }
        // Also set getTheme on window for compatibility
        if (typeof (window as any).getTheme !== 'function') {
            (window as any).getTheme = function (): undefined {
                return undefined;
            };
        }
        // Also set getPrefixCls on window for compatibility - CRITICAL
        if (typeof (window as any).getPrefixCls !== 'function') {
            (window as any).getPrefixCls = function (suffixCls?: string, customizePrefixCls?: string): string {
                if (customizePrefixCls) return customizePrefixCls;
                return suffixCls ? `ant-${suffixCls}` : 'ant';
            };
        }
    }
})();

export default null;
